export const API_CONFIG = {
    // Base URLs
    BUSINESS_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    PAYMEO_KEY: process.env?.REACT_APP_PAYMEO_API_KEY || "GALACTICUS",

    // ==================== AUTH ENDPOINTS ====================
    AUTH: {
        LOGIN: '/app/api/login',
        LOGOUT: '/app/api/logout',
        SIGNUP: '/app/api/signup',
        REGISTER_PHONE: '/app/api/register-phone',
        VERIFY_PHONE: '/app/api/verify-phone',
        VERIFY_OTP: '/app/api/verify-otp',
        RESEND_VERIFICATION_OTP: '/app/api/resend-verification-otp',
        FORGOT_PASSWORD: '/mango/forgotPassword',
        CONFIRM_TOKEN: '/confirmToken',
        CREATE_NEW_PASSWORD: '/createNewPassword',
        COMPLETE_PROFILE: '/complete-profile',
        IS_REGISTERED_BUSINESS: '/app/api/is-registered-business',
        VERIFY_BUSINESS: '/app/api/verify-business',
        COMPLETE_GOOGLE_SIGNUP: '/app/api/complete-google-signup',
        COMPLETE_GOOGLE_ACTIVATION: '/app/api/complete-google-activation',
        GOOGLE_LOGIN: '/app/api/google-login',
        GOOGLE_REGISTER: '/app/api/google-register',
        REFRESH_TOKEN: '/app/api/refresh-token',
        IS_LOGGED_IN: '/isLoggedIn',
        MAGIC_VALIDATE: '/magic/validate/magicLink',
        MAGIC_SET_PASSWORD: '/magic/set-password',
    },

    // ==================== USER/PROFILE ENDPOINTS ====================
    USER: {
        EXISTING_ACCOUNTS: '/app/existing-accounts',
        UPDATE_PERSONAL_DETAILS: '/updatePersonalDetails',
        UPDATE_PROFILE_PICTURE: '/updateProfilePicture',
        UPDATE_SIGNATURE: '/updateSignature',
        UPDATE_ACCOUNT_SETTINGS: '/api/update-account-settings',
        UPDATE_COMPANY_ADDRESS: '/api/update-company-address',
        VERIFY_USERNAME: '/verify-username',
        GET_BUSINESS_VERIFICATION: '/getBusinessVerificationData',
        SUBMIT_REAPPLICATION: '/submit-reapplication',
        UPDATE_SKIPPED: '/updateSkipped',
        SWITCH_TO_PERSONAL: '/api/switch-to-personal',
        SWITCH_TO_PERSONAL_TOKEN: '/api/switch-to-personal/token',
        SWITCH_TO_BUSINESS: '/api/switch-to-business',
        CLAIM_REGISTRATION_BALANCE: '/claim-registration-balance',
    },

    // ==================== PRODUCT ENDPOINTS ====================
    PRODUCTS: {
        MY_PRODUCTS: '/myProducts',
        PRODUCT_LIST: '/mango/manig/product-list',
        SHARED_PRODUCT: '/products/shared/v3',
        DELETE_PRODUCT: '/products',
        MAKE_NEGOTIABLE: '/make-negotiable',
        COLLECTIONS: '/collections',
        SAVE_CATEGORY: '/save-category',
        UPLOAD: '/upload/api',
    },

    // ==================== STORE ENDPOINTS ====================
    STORE: {
        STORE_V3: '/store/v3',
    },

    // ==================== ORDER ENDPOINTS ====================
    ORDERS: {
        CREATE_ORDER: '/api/order',
        STORE_ORDERS: '/api/store/orders',
        ORDER_SUCCESS: '/api/orders',
        ORDER_TRACK: '/api/orders/track',
        UPDATE_ORDER_STATUS: '/api/orders',
        CONFIRM_DELIVERY: '/api/orders',
        RESEND_CODE: '/api/orders',
        CHECK_PAYMENT_STATUS: '/api/check-payment-status',
        ORDER_CALLBACK: '/orders/callback',
        SERVICE_BOOKING: '/api/service-booking',
    },

    // ==================== CART ENDPOINTS ====================
    CART: {
        GET_CART: '/app/api/cart/cart',
        ADD_TO_CART: '/app/api/cart/cart/add',
        UPDATE_CART: '/app/api/cart/cart/update',
        REMOVE_FROM_CART: '/app/api/cart/cart/remove',
        CLEAR_CART: '/app/api/cart/cart/clear',
        SYNC_CART: '/app/api/cart/cart/sync',
    },

    // ==================== PAYMENT ENDPOINTS ====================
    PAYMENTS: {
        SEND_MONEY: '/sendMoney',
        REQUEST_MONEY: '/createPaymentRequest',
        CREATE_PIN: '/create-pin/v2',
        VERIFY_PIN: '/payment/verify-pin',
        VALIDATE_PIN: '/validate-pin',
        WITHDRAW_WALLET: '/withdraw/wallet',
        RESOLVE_ACCOUNT: '/resolve-account',
        CONNECT_BANK_ACCOUNT: '/connect-bank-account',
        DELETE_ACCOUNT: '/payment/delete-account',
        GET_BANKS: '/getBanks',
        BUY_CREDIT: '/wallet/credit/topup',
        CREDIT_TOPUP_GENERATE_LINK: '/payment/credit-topup/generate-link',
        CREDIT_TOPUP_VERIFY: '/payment/credit-topup/verify',
    },

    // ==================== INVOICE ENDPOINTS ====================
    INVOICES: {
        MY_INVOICES: '/myInvoices',
        MY_TOTAL_INVOICES: '/myTotalInvoices',
        GENERATE_INVOICE_NUMBER: '/generateInvoiceNumber',
        VALIDATE_INVOICE_NUMBER: '/validateInvoiceNumber',
        SAVE_INVOICE: '/saveInvoice',
        VIEW_INVOICE: '/invoice/view',
        PAY_INVOICE: '/pay',
    },

    // ==================== CUSTOMER ENDPOINTS ====================
    CUSTOMERS: {
        GET_CUSTOMERS_LIST: '/getCustomersList',
        GET_CUSTOMER: '/getCustomer',
        CREATE_CUSTOMER: '/customers/create',
        UPDATE_CUSTOMER: '/updateCustomer',
        DELETE_CUSTOMER: '/deleteCustomer',
        GET_PREVIOUS_RECIPIENTS: '/getPreviousRecipients',
    },

    // ==================== SETTINGS ENDPOINTS ====================
    SETTINGS: {
        BRAND_DETAILS: '/api/brand-details',
        BANK_DETAILS: '/api/bank-details',
        UPDATE_BRAND_DETAILS: '/api/update-brand-details',
        NOTIFICATION_PREFERENCES: '/api/notification-preferences',
        VAPID_PUBLIC_KEY: '/api/notification-preferences/vapid-public-key',
        PUSH_SUBSCRIBE: '/app/api/push/subscribe',
        PUSH_UNSUBSCRIBE: '/app/api/push/unsubscribe',
        VOICE_PREFERENCE: '/user/update-voice-preference',
        LINKED_DEVICES: '/api/get-linked-devices',
        SIGN_OUT_ALL_DEVICES: '/api/sign-out-all-devices',
        REMOVE_DEVICE: '/api/remove-device',
    },

    // ==================== DASHBOARD ENDPOINTS ====================
    DASHBOARD: {
        DASHBOARD: '/dashboard',
    },

    // ==================== ASKS/FEED ENDPOINTS ====================
    ASKS: {
        GET_ASKS: '/app/personal/get-asks',
        GET_ASK: '/app/personal/ask',
        POST_ASK: '/app/personal/post-ask',
        UPDATE_ASK: '/app/personal/ask',
        DELETE_ASK: '/app/personal/ask',
        ASK_RESPONSE: '/app/personal/asks',
        ASK_OFFERS: '/app/personal/asks',
    },

    // ==================== CHAT / MESSAGING ENDPOINTS ====================
    CHAT: {
        GET_ASK_MESSAGES: '/app/personal/chat/asks',
        SEND_ASK_MESSAGE: '/app/personal/chat/asks',
        GET_FLOWS: '/app/personal/chat/flows',
        GET_FLOW: '/app/personal/chat/flows',
        MARK_FLOW_READ: '/app/personal/chat/flows',
    },

    // ==================== NEGOTIATION ENDPOINTS ====================
    NEGOTIATIONS: {
        INIT: '/app/api/negotiations/init',
        UPDATE_CONTEXT: '/app/api/negotiations',
        ACCEPT: '/app/api/negotiations',
        CANCEL: '/app/api/negotiations',
        VERIFY_CHECKOUT: '/app/api/negotiations/verify-checkout',
        GET_SESSION: '/app/api/negotiations',
        LOG: '/app/api/negotiations',
        ACTIVE_PRODUCT: '/app/api/negotiations/product',
    },

    // ==================== MARKET ENDPOINTS ====================
    MARKETS: {
        GET_MARKETS: '/api/markets',
        MARKET_FORM_SCHEMA: '/api/markets',
        UPDATE_MARKET: '/api/update-market',
        SAVE_GENERIC_CATEGORY: '/api/save-generic-category',
    },

    // ==================== PERSONAL ENDPOINTS ====================
    PERSONAL: {
        LOGIN: '/app/personal/login',
        ADDRESSES: '/app/personal/addresses',
        CREATE_ADDRESS: '/app/personal/address',
        UPDATE_ADDRESS: '/app/personal/address',
    },

    // ==================== DOWNLOAD ENDPOINTS ====================
    DOWNLOAD: {
        BANK_DETAILS_PDF: '/download/bank-details/pdf',
        DOWNLOAD_PIN_VERIFY: '/api/verify-download-pin',
        DOWNLOAD_PROXY: '/api/download-proxy',
    },

    // ==================== REFUND ENDPOINTS ====================
    REFUNDS: {
        REFUND_STATUS: '/api/refunds/status',
        REQUEST_REFUND: '/api/refunds/request',
        REJECTION_DETAILS: '/get-rejection-details',
    },

    // ==================== META CATALOG ENDPOINTS ====================
    META_CATALOG: {
        STATUS: '/meta-catalog/status',
        PRODUCTS: '/meta-catalog/products',
        SYNC: '/meta-catalog/sync',
        DISCONNECT: '/meta-catalog/disconnect',
        UPLOAD: '/meta-catalog/upload',
    },

    // ==================== ADMIN ENDPOINTS ====================
    ADMIN: {
        LOGIN: '/admin/login',
        LOGOUT: '/admin/logout',
        ME: '/admin/me',
        VERIFY_TURNSTILE: '/admin/verify-turnstile',
        FORGOT_PASSWORD: '/admin/forgot-password',
        RESET_PASSWORD: '/admin/reset-password',
        USERS_REGULAR: '/admin/users/regular',
        USERS_BUSINESS: '/admin/users/business',
        USER_DETAILS: '/admin/users',
        TOGGLE_STATUS: '/toggle-status',
        ACCOUNTS: '/admin/accounts',
        CREATE_ACCOUNT: '/admin/accounts/create',
        DISABLE_ACCOUNT: '/disable',
        BUSINESS_VERIFICATIONS: '/admin/business-verifications',
        WHATSAPP_PROFILE: '/admin/whatsapp/profile/update',
    },

    // ==================== TRANSACTIONS ENDPOINTS ====================
    TRANSACTIONS: {
        PAYMENT_REQUESTS: '/transactions/payments/requests',
    },

    // ==================== HEALTH ENDPOINTS ====================
    HEALTH: {
        CHECK: '/health',
    },

    // ==================== CSRF ENDPOINTS ====================
    CSRF: {
        TOKEN: '/appendage/csrf-token',
    },
};
